import Rete from "rete";
import { NumberSocket, NumberControl } from "../rete-controls/NumberControl.js";
import { OperationSocket } from "../rete-controls/OperationsControl.js";
import Calc from "../../Utils/Calculator.js"
import ReteComponentStore from "../ReteComponentStore.js"

export default class NumberAdderComponent extends Rete.Component {
  constructor() {
    super("Number Adder"); // name
    this._calc = new Calc();
    this._categories = ["Statistics Nodes", "tryMe"];
  }

  builder(node) {
    let inp1 = new Rete.Input("in1", "a", NumberSocket);
    let inp2 = new Rete.Input("in2", "b", NumberSocket);
    let inp3 = new Rete.Input("in3", "op", OperationSocket);

    let out1 = new Rete.Output("out1", "OUT", NumberSocket);
    let numControl1 = new NumberControl(this.editor, "display1", true);
    let numControl2 = new NumberControl(this.editor, "display2", true);

    return node
      .addInput(inp1)
      .addInput(inp2)
      .addInput(inp3)
      .addOutput(out1)
      .addControl(numControl1)
      .addControl(numControl2);
  }

  worker(node, inputs, outputs) {
    let in1 = +inputs["in1"];
    let in2 = +inputs["in2"];
    let op = inputs["in3"][0];

    if (in1.length !== 0) {
      this.editor.nodes
        .find(n => n.id == node.id)
        .controls.get("display1")
        .setValue("A =" + in1.toFixed(2));
    }

    if (in2.length !== 0) {
      this.editor.nodes
        .find(n => n.id == node.id)
        .controls.get("display2")
        .setValue("B =" + in2.toFixed(2));
    }

    if (in2.length !== 0 && in1.length !== 0) {
      outputs["out1"]  = this._calc.doMath(op,+in1,+in2);      
    }
  }
}

//ReteComponentStore.add(new NumberAdderComponent());